import reduce from "lodash/reduce";

export const formatQuery = (searchKeys) => {
  return reduce(searchKeys, function (str, val, key) {
    if (!val) {
      return str;
    } else if (str.length <= 0) {
      return key + '=' + val;
    } else {
      return str + '&' + key + '=' + val;
    }
  }, '');
};

export const returnQueryString = (searchParams) => {
  const address = searchParams.location ? encodeURIComponent(searchParams.location.replace(/\-\-/g, ', ').replace(/\-/g, ' ')) : undefined;
  const searchKeys = {
    viewport_bbox: searchParams.viewport_bbox,
    bbox_of_interest: searchParams.bbox_of_interest,
    point_of_interest: searchParams.point_of_interest,
    ffilter: 'web-search',
  };

  if (!searchParams.bbox_of_interest && !searchParams.point_of_interest) {
    searchKeys.address_bbox = address;
  }
  return formatQuery(searchKeys);
};
